import type { Base } from '../base';

export namespace ClientEvent {
    // 页面信息
    export interface UrlPackage extends Base.UrlPackage {
        page2: string; // 一级页面。参考埋点需求填写即可
    }

    // 页面元素详细信息
    export interface ElementPackage extends Base.ElementPackage {
        action2: string; // 业务类型字符串版本
    }

    export interface LaunchEvent {
        cold: boolean;
        detail: string;
        mode: number;
        source: number;
        target: string;
    };
    export interface AppUsageStatEvent {
        last_url_package: Base.UrlPackage;
        app_use_duration: number;
    };
    export interface DeviceStatEvent {
        battery: number;
        density_dpi: number;
        model: string;
        os_version: string;
        screen_height: number;
        screen_width: number;
    };
    export interface ExceptionEvent {
        type: number;
        message: string;
        url_package: Base.UrlPackage;
    };
    export interface CustomStatEvent {
        key: string;
        value: string;
    };
    export interface StatPackage {
        launch_event?: LaunchEvent;
        app_usage_stat_event?: AppUsageStatEvent;
        device_stat_event?: DeviceStatEvent;
        custom_stat_event?: CustomStatEvent;
    };

    export enum ShowType {
        UNKNOWN2 = 0, // 未知
        PAGE = 1, // 页面
    }

    // 页面区域信息   页面+区域+元素
    export interface AreaPackage {
        name: string; // 区域名称
        params: string; // 区域补充参数
    }

    // 曝光事件
    export interface ShowEvent extends Base.ShowEvent {
        type?: ShowType;
        show_type?: number; // 记录进入或离开页面的方式
        page_show_seq?: number; // 页面展示的Sequence id，每次展示一次页面就加1(页面展示事件才有意义)
        content_wrapper?: string; // 上报业务相关信息，客户端将content_wrapper转成json上报
        extra_message?: string; // 用于存放一些点击时候的额外信息，可以是 json, string 分割等，此字段仅限于客户端内部分析使用！
        area_package?: AreaPackage; // 页面区域信息
    }

    // 任务事件
    export interface TaskEvent extends Base.TaskEvent {
        action2: string;
        content_package?: any; // 相关内容，TODO: 比较复杂，暂时没写
        content_wrapper?: string; // 上报业务相关信息，客户端将content_wrapper转成json上报
    }

    export interface ClickEvent extends Base.Event {
        type: number; // 点击类型
        direction: Base.Direction; // Action={PULL, DRAG}时有意义
        url_package: Base.UrlPackage; // 页面
        element_package: Base.ElementPackage; // 所操作的元素信息
        content_package?: any; // 相关内容，TODO: 比较复杂，暂时没写
        extra_message?: any; // 用于存放一些点击时候的额外信息，可以是 json, string 分割等，此字段仅限于客户端内部分析使用！
        content_wrapper?: string; // 上报业务相关信息，客户端将content_wrapper转成json上报
        area_package?: AreaPackage; // 页面区域信息
    }

    export interface CustomEvent extends Base.CustomEvent {

    }

    export interface EventPackage {
        show_event?: ShowEvent;
        click_event?: ClickEvent;
        task_event?: TaskEvent;
        custom_event?: CustomEvent;
    }

    export interface VideoStatEvent extends Base.Event {
        video_stat_event: {
            // 视频总时长
            duration?: number;
            // 播放时长
            played_duration?: number;
            // 是否已经下载
            downloaded?: boolean;
            //  从进入页面到开始播放准备的时长 单位ms
            prepare_duration?: number;
            // 进入视频播放详情页页面的时间戳 ms
            enter_time?: number;
            // 离开视频播放页面的时间戳
            leave_time?: number;
            // 视频的类型
            video_type?: string;
            // 播放的时候的类型, 由于有些机型不支持 H265，或者做 A/B test 的时候视频类型和播放类型不一致.
            play_video_type?: string;
            // 作品ID 废弃
            photo_id?: number;
            // 用户离开播放页面的方式
            leave_action?: string;
            // 视频播放的平均fps
            average_fps?: number;
            // 媒体类型：短视频、图片、图集等
            media_type?: string;
            // 作品ID
            s_photo_id?: number;
            // 记录当前页面及extra参数信息
            url_package?: Base.UrlPackage;
            // 记录来源页面相关参数，包括来源页面、exptag、llsid等
            refer_url_package?: Base.UrlPackage;
            // 播放器基本状态信息，用json串上报
            video_qos_json?: string;
            // 从点击feed到渲染第一帧总时长
            click_to_first_frame_duration?: number;
            // 信号强度，单位为dbm，wifi/4g/3g/2g下均需上报
            rssi?: number;
            // 用户进入播放器页面的方式
            enter_player_action?: string;
            // 用于记录该Event的其他附属字段，可以是普通字符串或json字段
            summary?: string;
            // 芯片名字
            board_platform?: string;
            // 用户观看视频前是否收藏
            collect_before_status?: string;
            // 用户观看视频后是否收藏
            collect_after_status?: string;
            session_uuid?: string;
            // android soc的名字，比如Kirin 960
            soc_name?: string;
        };
    }
}
